var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9358_76652)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32796 12.9824V7.51347C10.2694 8.42702 11.7731 9.30954 13.5515 10.261C12.0847 11.0745 10.2694 11.9872 8.32796 12.9824ZM19.1478 4.79353C18.8129 4.3523 18.2421 4.00884 17.6344 3.89513C15.8483 3.55595 4.70518 3.55498 2.92 3.89513C2.43269 3.98649 1.99876 4.2073 1.626 4.55037C0.055349 6.00818 0.547516 13.8259 0.926104 15.0923C1.0853 15.6404 1.29111 16.0357 1.55029 16.2952C1.88423 16.6383 2.34144 16.8745 2.8666 16.9804C4.33727 17.2846 11.9139 17.4547 17.6033 17.0261C18.1275 16.9348 18.5915 16.6909 18.9575 16.3333C20.4097 14.8813 20.3107 6.62453 19.1478 4.79353Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9358_76652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4907,
    height: 19.4907,
    fill: "white",
    transform: "translate(0.537109 0.717407)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.114c96f6.svg";
export { ForwardRef as ReactComponent };